"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUserAccountShown = void 0;

var _landing = require("../model/landing");

/** @prettier */
const isUserAccountShown = auth => auth.type === _landing.AuthorizationType.USER_ID || auth.type === _landing.AuthorizationType.WEBHOOK || auth.type === _landing.AuthorizationType.LOGIN && auth.loginId;

exports.isUserAccountShown = isUserAccountShown;